import React from "react";

/**
 * Premium contractor logo — warm espresso square mark with gold chamfer.
 */
export default function Logo({ variant = "dark", size = "md", className = "" }) {
  const inkColor = variant === "light" ? "#FAF8F4" : "#2B2420";
  const mutedColor = variant === "light" ? "rgba(250,248,244,0.72)" : "#8A7F74";

  const dims = size === "sm" ? { box: 32, text: "text-base", sub: "text-[9px]" } :
               size === "lg" ? { box: 48, text: "text-2xl", sub: "text-[11px]" } :
               { box: 40, text: "text-lg md:text-xl", sub: "text-[10px]" };

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg
        width={dims.box}
        height={dims.box}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        className="shrink-0"
      >
        <rect width="48" height="48" fill="#2B2420" />
        <path d="M0 0 L14 0 L0 14 Z" fill="#C9A24C" />
        <path
          d="M34 16.5 C31.8 14.9 29.1 14 26.2 14 C19.5 14 14 19.5 14 26.2 C14 32.9 19.5 38.4 26.2 38.4 C29.1 38.4 31.8 37.5 34 35.9"
          stroke="#FAF8F4"
          strokeWidth="3.6"
          strokeLinecap="square"
          fill="none"
        />
      </svg>

      <div className="leading-tight">
        <div
          className={`font-black tracking-tighter ${dims.text}`}
          style={{ fontFamily: "Cabinet Grotesk", color: inkColor }}
        >
          CONSTANTINOV
        </div>
        <div
          className={`uppercase font-bold tracking-[0.24em] mt-0.5 ${dims.sub}`}
          style={{ color: mutedColor }}
        >
          LTD · London Contractors
        </div>
      </div>
    </div>
  );
}
